import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import firebase from "firebase/app";

// Sentry configuration
import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";

Sentry.init({
  dsn: "https://ee53966bb1bf4ca4a00c037d43c6c6b8@sentry.io/1482681",
  environment: "stilt-1-signup",
  integrations: [
    new Integrations.Vue({ Vue, attachProps: true, logErrors: true }),
  ],
});

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDjQDwrqqMD17aSWc5AbCKIuoc8Vg4pEyg",
  authDomain: "scaffoldtracker.firebaseapp.com",
  databaseURL: "https://scaffoldtracker.firebaseio.com",
  projectId: "scaffoldtracker",
  storageBucket: "scaffoldtracker.appspot.com",
  messagingSenderId: "280039922335",
  appId: "1:280039922335:web:a888f42e802e2e6f",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount("#app");
